class ProductVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('.js-video') || this.querySelector('.js-iframe-video');
    this.buttonPlay = this.querySelector('.js-video-play');
    this.banner = this.querySelector('.js-banner');
    this.content = this.querySelector('.js-content');
    this.isIframe = this.video.classList.contains('js-iframe-video');

    if (this.video) {
      this.options = {
        breakpoints: { default: { src: this.video.getAttribute('data-src') } },
      };
      // get a list of video switching points and links to the videos themselves
      if (!this.isIframe) {
      this.video
        .querySelectorAll('[data-src]')
        .forEach(
          (element) =>
            (this.options.breakpoints[element.getAttribute('data-mw')] = {
              src: element.getAttribute('data-src'),
            })
        );

        this.video.innerHTML = ''; // we clean up so that there is nothing superfluous
      } else {
        this.options.breakpoints[this.video.getAttribute('data-mw')] = {
          src: this.video.getAttribute('data-mobile-video'),
        };
      }

      // run the handler and track the change in screen width
      this.responseVideo(this.options);
      window.addEventListener('resize', () => this.responseVideo(this.options));
    }
  }

  connectedCallback() {
    this.buttonPlay.addEventListener('click', (event) => {
      event.preventDefault();

      this.playVideo();

      this.content.classList.add('hide-content');

      if (this.banner) {
        this.banner.classList.add('hidden')
      }
    });
  }

  playVideo() {
    if (!this.isIframe) {
      this.video.play();
    } else {
      const url = this.video.getAttribute('src');
      this.video.setAttribute('src', url + '?autoplay=1;');
    }
  }

  /**
   * Change src value of video link to fit screen width
   *
   * @param {Object} options object with options
   */
  responseVideo(options) {
    const { breakpoints } = options;
    const widthNow = this.video.getAttribute('data-width-now') || null;
    const maxBreakpoint = Math.max.apply(
      Math,
      Object.keys(breakpoints)
        .filter((key) => Number(key) >= document.body.clientWidth)
        .map(Number)
    );
    const nowBreakpoint = Number.isInteger(maxBreakpoint) ?  maxBreakpoint : 'default'; // choose either the maximum value, if not, then the default

    if (widthNow && widthNow == nowBreakpoint) return; // check if the video needs to be changed

    this.video.setAttribute('data-width-now', nowBreakpoint);
    if (breakpoints[nowBreakpoint].src) {
      this.video.src = breakpoints[nowBreakpoint].src;
    }
    this.playVideo();
  }
}

customElements.define('product-video', ProductVideo);
